var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "light" }, [_vm._v("Recent Users List")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersPoduct" } }, [
            _vm._v("Product")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.product,
                  expression: "filters.product"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "recentUsersPoduct" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.filters,
                      "product",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.getUsersList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "toolkit" } }, [
                _vm._v("Toolkit")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "pathways" } }, [
                _vm._v("Pathways")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersLicenseType" } }, [
            _vm._v("License Type")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.licenseType,
                  expression: "filters.licenseType"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "recentUsersLicenseType" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.filters,
                      "licenseType",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.getUsersList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "trial" } }, [_vm._v("Trial")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "premium" } }, [
                _vm._v("Enterprise")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersActiveIn" } }, [
            _vm._v("Active In")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.activeIn,
                  expression: "activeIn"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "recentUsersActiveIn" },
              on: {
                input: _vm.setStartAndEndDates,
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.activeIn = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { domProps: { value: 30 } }, [
                _vm._v("Last 30 Days")
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 60 } }, [
                _vm._v("Last 60 Days")
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 90 } }, [
                _vm._v("Last 90 Days")
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 365 } }, [_vm._v("Last Year")]),
              _vm._v(" "),
              _c("option", { domProps: { value: 365 * 5 } }, [
                _vm._v("Last 5 Years")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersTitle" } }, [
            _vm._v("Title")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.title,
                expression: "filters.title"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "recentUsersTitle", type: "text" },
            domProps: { value: _vm.filters.title },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "title", $event.target.value)
                },
                _vm.throttledGetUsersList
              ]
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersDistrict" } }, [
            _vm._v("District")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.district,
                expression: "filters.district"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "recentUsersDistrict", type: "text" },
            domProps: { value: _vm.filters.district },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "district", $event.target.value)
                },
                _vm.throttledGetUsersList
              ]
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("label", { attrs: { for: "recentUsersState" } }, [
            _vm._v("State")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.state,
                expression: "filters.state"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "recentUsersState", type: "text" },
            domProps: { value: _vm.filters.state },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "state", $event.target.value)
                },
                _vm.throttledGetUsersList
              ]
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.loading
        ? _c("p", { staticClass: "text-muted" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
            _vm._v(" Loading users list...\n  ")
          ])
        : _vm.error
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("h4", [_vm._v("Error Loading Users List")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.userList.length > 0
        ? _c("v-client-table", {
            ref: "recentUsersTable",
            attrs: {
              data: _vm.userList,
              columns: _vm.eventsTableColumns,
              options: _vm.eventsTableOptions
            },
            on: {
              sorted: _vm.throttledGetUserEventCounts,
              pagination: _vm.throttledGetUserEventCounts
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "name",
                  fn: function(props) {
                    return _c("b", {}, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: `#!/user_events?uuid=${props.row.uuid}`,
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(props.row.name))]
                      )
                    ])
                  }
                },
                {
                  key: "email",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v("\n      " + _vm._s(props.row.email) + "\n    ")
                    ])
                  }
                },
                {
                  key: "title",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v("\n      " + _vm._s(props.row.title) + "\n    ")
                    ])
                  }
                },
                {
                  key: "district",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v("\n      " + _vm._s(props.row.district) + "\n    ")
                    ])
                  }
                },
                {
                  key: "state",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v("\n      " + _vm._s(props.row.state) + "\n    ")
                    ])
                  }
                },
                {
                  key: "tk_last_active",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            props.row.tk_last_active
                              ? new Date(
                                  props.row.tk_last_active
                                ).toLocaleDateString("en-US")
                              : ""
                          ) +
                          "\n    "
                      )
                    ])
                  }
                },
                {
                  key: "pw_last_active",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            props.row.pw_last_active
                              ? new Date(
                                  props.row.pw_last_active
                                ).toLocaleDateString("en-US")
                              : ""
                          ) +
                          "\n    "
                      )
                    ])
                  }
                },
                {
                  key: "event_count",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm.loadingEventCounts &&
                      !_vm.userEventCounts[props.row.uuid]
                        ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        : _vm._e(),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.userEventCounts[props.row.uuid]) +
                          "\n    "
                      )
                    ])
                  }
                }
              ],
              null,
              true
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }